import { gql } from '@apollo/client';

/**
 * Client-specific GraphQL mutations
 * These mutations use the standard backend mutations.
 * Authorization is handled by the backend based on the authenticated user.
 */

// Complete a task (backend validates client owns task)
export const COMPLETE_MY_TASK = gql`
  mutation CompleteTask($id: ID!, $clientNotes: String) {
    completeTask(id: $id, clientNotes: $clientNotes) {
      id
      status
      completedAt
      clientNotes
    }
  }
`;

// Get document upload URL
export const GET_DOCUMENT_UPLOAD_URL = gql`
  mutation GetDocumentUploadUrl($input: DocumentUploadInput!) {
    getDocumentUploadUrl(input: $input) {
      uploadUrl
      s3Key
    }
  }
`;

// Create document record after upload
export const CREATE_DOCUMENT = gql`
  mutation CreateDocument($input: CreateDocumentInput!) {
    createDocument(input: $input) {
      id
      fileName
      fileType
      fileSize
      description
      createdAt
    }
  }
`;

// Send a message using the standard sendMessage mutation
export const SEND_MESSAGE = gql`
  mutation SendMessage($input: SendMessageInput!) {
    sendMessage(input: $input) {
      id
      conversationId
      clientId
      staffId
      senderId
      recipientId
      content
      isRead
      isEdited
      createdAt
    }
  }
`;

// Mark a single message as read
export const MARK_MESSAGE_AS_READ = gql`
  mutation MarkMessageAsRead($id: ID!, $conversationId: ID!, $sentAt: AWSDateTime!) {
    markMessageAsRead(id: $id, conversationId: $conversationId, sentAt: $sentAt) {
      id
      conversationId
      isRead
    }
  }
`;

// Update client profile
export const UPDATE_USER = gql`
  mutation UpdateUser($id: ID!, $input: UpdateUserInput!) {
    updateUser(id: $id, input: $input) {
      id
      phoneNumber
      address {
        street1
        street2
        city
        state
        zipCode
      }
    }
  }
`;
